
<generic-card
  [isLoading]="isLoading"
  >
    @if(!isLoading){
      <div style="display: block">
          <!-- Barre d’actions locale -->
          <div class="ts-toolbar">
            @if (canEdit) {
              <ed-button 
                      class="btn"    
                      [colorSchema]="ButtonColors.Primary"
                      [disabled]="!editing() || isDirty()"
                      (click)="onSaveClick()">
                Sauvegarder
              </ed-button>
            }
          </div>

            <div class="ts-table-scroll">
              <table class="ts-table">
                <thead>
                  <tr>
                    <th class="col-project">Projet / Phase</th>
                    @for (day of days(); track day) {
                      <th class="col-day">
                        <div class="th-day">
                          <span class="th-dayname">{{ day | date: 'EEE' }}</span>
                          <span class="th-date">{{ day | date:'dd/MM' }}</span>
                        </div>
                      </th>
                    }
                    <th class="col-remaining">
                      <div class="th-day">
                          <span class="th-dayname">Jours restants</span>
                          <span class="th-date">(- jours déclarés)</span>
                        </div> </th>
                    @if(canEdit){
                      <th class="col-actions"></th>
                      }
                  </tr>
                </thead>

                <tbody>
                  @for (row of rows(); track row.phaseId; let r = $index) {
                    <tr>
                      <!-- Projet / Phase -->
                      <td class="col-project">
                        @if(canEdit){
                            <ed-search
                              class="w-100  mb-6"
                              placeholder="Séléctionnez un projet"
                              [ngModel]="row.projectId"
                              (ngModelChange)="onProjectChange(r, $event)"
                              [options]="filteredProjectOptions()"
                              [isMulti]="false"
                              (search)="onAddSearchChange($event)"
                              [disabled]="!canEdit"
                              >
                              
                            </ed-search>
                         
                          @if (row.projectId) {
                            <ed-select
                              class="w-100"
                              placeholder="Séléctionnez une phase"
                              [options]="phaseOptionsByProject().get(row.projectId!) ?? []"
                              [ngModel]="row.phaseId"
                              [disabled]="!canEdit"
                              (ngModelChange)="onPhaseChange(r, $event)">
                            </ed-select>
                          }
                        }
                        @else {
                          @let project=projectsLinks()[row.projectId];
                          @let phase=phaseLinks()[row.phaseId];
                          <div class="container-label">
                            @if(project){
                              <div class="project-label"><a [routerLink]="project.link"> {{project.label}}</a></div>
                            }
                            @if(phase){
                               <div class="phase-label"><a  [routerLink]="phase.link"> {{phase.label}}</a></div>
                            }
                          </div>  
                        }
                      </td>

                      <!-- 5 jours -->
                      @for (d of days(); track d; let c = $index) {
                        <td class="col-day">
                          @if(canEdit){
                            <ed-numberfield
                              [id]="'cell-' + r + '-' + c"
                              [disabled]="!canEdit || !row.phaseId"
                              unit="%"
                              [ngModel]="findDailyEntryValue(c, r)"
                              (ngModelChange)="onCellInput(r, c, $event)"
                              ></ed-numberfield>
                            }
                            @else{
                              @let value = findDailyEntryValue(c, r);
                              @if(value && value > 0){
                                <span> {{value}} %</span>
                              }
                            }
                        </td>
                      }

                      <!-- Jours restants -->
                      <td class="col-remaining">
                        <div class="th-day">
                          
                          {{daysRemaing(row.projectId)}}
                          <span class="th-date">(-{{projectSum(r) | number:'1.0-1'}})</span>
                            
                          </div>
                        
                      </td>

                      <!-- Actions -->
                      @if (canEdit) {
                      <td class="col-actions">
                          <ed-button 
                            [small]="true" 
                            [icon]="'icon-trash-01'" 
                            [colorSchema]="ButtonColors.Red"
                            (click)="removeRow(r)">
                          </ed-button>
                      </td>
                      }
                    </tr>
                  }

                  <!-- Avant-dernière ligne : ajout (masquée si !canEdit) -->
                  @if (canEdit) {
                    <tr class="add-row">
                      <td class="col-project add-controls">
                        
                        <ed-search
                          class="w-100"
                          placeholder="Ajouter un projet"
                          [ngModel]="addSelectedProjectId()"
                          (ngModelChange)="onAddProjectChange($event)"
                          [options]="filteredProjectOptions()"
                          [isMulti]="false"
                          (search)="onAddSearchChange($event)"
                          >
                          
                        </ed-search>
                      
                        @let projectId= addSelectedProjectId();
                        @if (projectId) {
                          @let phaseId=addSelectedPhaseId();
                          <ed-select
                            class="w-100"
                            placeholder="Séléctionnez une phase"
                            [options]="phaseOptionsByProject().get(projectId) ?? []"
                            [ngModel]="phaseId"
                            (ngModelChange)="onAddPhaseChange($event)">
                          </ed-select>
                        }
                      </td>
                      @for (i of [0,1,2,3,4]; track i) {
                      <td class="col-day dim">—</td>
                      }
                      <td class="col-remaining dim">
                        <div class="th-day">—</div>
                      </td>
                      @if(canEdit){
                      <td class="col-actions dim">—</td>
                      }
                    </tr>
                  }
                </tbody>

                <!-- Totaux -->
                <tfoot>
                  <tr>
                    <td class="col-project total-label">Total</td>
                    @for (d of days(); track d) {
                      <td class="col-day" [ngClass]="{ ok: isDayOk(d), ko: !isDayOk(d) }">
                        {{ columnTotal(d) | number:'1.0-1' }} %
                      </td>
                    }
                    <td class="col-remaining dim"></td>
                    @if(canEdit){
                        <td class="col-actions dim"></td>
                      }
                  </tr>
                </tfoot>
              </table>
            </div>
      </div>
      }
      @else{
        <div >
            <ed-skeleton-list
                [numberOfRows]="5"
                [numberOfBlocs]="7"
              ></ed-skeleton-list>
        </div>
      }
</generic-card>
